'use es6';

import PropTypes from 'prop-types';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const renderDragHandleContent = orientation => {
  const dimensions = orientation === 'horizontal' ? [6, 2] : [2, 6];
  const dot = '·';
  const LF = String.fromCharCode(10);
  let content = '';
  for (let y = 0; y < dimensions[1]; y++) {
    for (let x = 0; x < dimensions[0]; x++) {
      content += dot;
    }
    content += LF;
  }
  return content;
};
const DragHandleDots = ({
  color = BATTLESHIP,
  orientation = 'horizontal'
}) => {
  return /*#__PURE__*/_jsx("div", {
    style: {
      color,
      lineHeight: 0.3,
      margin: '0 auto',
      whiteSpace: 'pre-wrap',
      fontSize: '18px'
    },
    children: renderDragHandleContent(orientation)
  });
};
DragHandleDots.propTypes = {
  color: PropTypes.string,
  orientation: PropTypes.string
};
export default DragHandleDots;